import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import styled from 'styled-components';
import SelectedCompleteButton from './SelectedCompleteButton';
import icon from 'images/mapClustoer/sikdae_log.svg';

const SideTitle = styled.div`
  padding: 48px 30px 53px 30px;
  font-style: normal;
  font-weight: bold;
  font-size: 26px;
  line-height: 38px;
  letter-spacing: -0.06em;
  color: #000000;

  & img {
    padding-bottom: 16px;
  }

  @media only screen and (max-width: 768px) {
    font-size: 20px;
    line-height: 28px;
    letter-spacing: -0.05em;
    padding: 20px 16px 16px 30px;
  }
`;

const MapHeader = ({ address = [], onSelected, value }) => (
  // <Segment clearing>
  //   <Header as="h2" floated="left">
  //     식당 선택
  //     <Header.Subheader>최대 선택 개수 만큼 식당을 선택한 후 선택완료 해주세요</Header.Subheader>
  //   </Header>
  //   <Header as="h2" floated="right">
  //     {status === 'PROPOSE' ? <SelectedCompleteButton onSelectedComplete={onComplete} /> : null}
  //   </Header>
  // </Segment>
  <SideTitle>
    <img alt="logo" src={icon} />
    <div className="text">
      안녕하세요, 담당자님
      <br />
      <Dropdown selection value={value} options={address} onChange={onSelected} /> 에서
      <br />
      제휴할 식당을 선택 후 제출해주세요.
    </div>
  </SideTitle>
);

export default MapHeader;
